import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";
import ManageCustomField from '../../components/ManageCustomField/ManageCustomField';


const defaultTheme = createTheme();

const Page = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Manage Custom Fields</h1>
          <p>Configure custom fields for tracking numbers. Define field types and validation rules.</p>
        </div>
      </div>

      <ManageCustomField />
    </ThemeProvider>
  );
};

export default Page;